import {
  LOAD_CONFERENCE_BRIDGES_FAIL,
  LOAD_CONFERENCE_BRIDGES_START,
  LOAD_CONFERENCE_BRIDGES_SUCCESS,
  DELETE_CONFERENCE_BRIDGES_FAIL,
  DELETE_CONFERENCE_BRIDGES_START,
  DELETE_CONFERENCE_BRIDGES_SUCCESS,
  DELETE_CONFERENCE_BRIDGE_SUCCESS,
  UPDATE_CONFERENCE_BRIDGE_FAIL,
  UPDATE_CONFERENCE_BRIDGE_START,
  UPDATE_CONFERENCE_BRIDGE_SUCCESS,
  PROCESSING_CONFERENCE_BRIDGES_ONTO,
  LOAD_PANEL_ITEM,
  IS_FORM_DIRTY,
} from 'actions/externalConferenceBridgeList';

import {
  getListPageSuccessNewData,
  getListPageSuccessNewLinks,
} from 'reducers/utils';

const defaultState = {
  data: [],
  error: false,
  loading: true,
  total: 0,
  item: undefined,
  isFormDirty: false,
};

export default function externalConferenceBridgesListPage(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case LOAD_PANEL_ITEM:
      return {
        ...state,
        item: action.payload,
      };

    case IS_FORM_DIRTY:
      return {
        ...state,
        isFormDirty: action.payload,
      };

    case LOAD_CONFERENCE_BRIDGES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case LOAD_CONFERENCE_BRIDGES_START:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case DELETE_CONFERENCE_BRIDGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        total: state.total - 1,
        item: {},
      };
    }

    case DELETE_CONFERENCE_BRIDGES_SUCCESS:
      return {
        ...state,
        item: {},
      };

    case UPDATE_CONFERENCE_BRIDGE_SUCCESS:
      return {
        ...state,
        item: {},
        total: state.total + 1,
      };

    case LOAD_CONFERENCE_BRIDGES_SUCCESS: {
      const { data, links, total } = action.payload;
      return {
        ...state,
        data: getListPageSuccessNewData(state, data, links),
        error: false,
        links: getListPageSuccessNewLinks(links),
        loading: false,
        total,
      };
    }

    case UPDATE_CONFERENCE_BRIDGE_FAIL:
    case DELETE_CONFERENCE_BRIDGES_FAIL:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case UPDATE_CONFERENCE_BRIDGE_START:
    case DELETE_CONFERENCE_BRIDGES_START:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case PROCESSING_CONFERENCE_BRIDGES_ONTO:
      return {
        ...state,
      };

    default:
      return state;
  }
}
